module.exports = __webpack_public_path__ + "img/34d1a8f.png";